import type * as Type from "../type";

type Props = {
	optionPmsGetAvailableOptionListServerData: Type.ServerData.OptionPmsGetAvailableOptionListServerData | undefined;
};
type Result = {
	optionPmsGetAvailableOptionListQueryData:
		| Type.QueryData.OptionPmsGetAvailableOptionList.OptionPmsGetAvailableOptionListQueryData
		| undefined;
};

export const useOptionPmsGetAvailableOptionListConverter = ({
	optionPmsGetAvailableOptionListServerData,
}: Props): Result | undefined => {
	if (!optionPmsGetAvailableOptionListServerData) return undefined;

	/**
	 * QueryData への変換処理
	 */
	return {
		optionPmsGetAvailableOptionListQueryData: {
			optionPmsGetAvailableOptionList: {
				id: optionPmsGetAvailableOptionListServerData.optionPmsGetAvailableOptionList.id,
				hotelID: optionPmsGetAvailableOptionListServerData.optionPmsGetAvailableOptionList.hotelID,
				date: optionPmsGetAvailableOptionListServerData.optionPmsGetAvailableOptionList.date,
				options: optionPmsGetAvailableOptionListServerData.optionPmsGetAvailableOptionList.options.map(
					(option) => ({
						optionID: option.optionID,
						name: option.name,
						availableAmount: option.availableAmount ?? null,
						subOptions: option.subOptions?.map((subOption) => ({
							subOptionID: subOption.subOptionID,
							name: subOption.name,
							availableAmount: subOption.availableAmount,
						})),
					}),
				),
			},
		},
	};
};
